import React from "react";
import { AiOutlineClose } from "react-icons/ai";
import styled from "styled-components";

interface Props {
    headingText: string;
    onCloseHandler: () => void;
}

const ModalHeader: React.FC<Props> = ({
    headingText,
    children, // allow for custom content
    onCloseHandler,
}) => {
    return (
        <Header>
            <span>
                <span>{headingText.toUpperCase()}</span>
                {children}
            </span>
            <div onClick={() => onCloseHandler()}>
                <AiOutlineClose />
            </div>
        </Header>
    );
};

const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;

    height: 4rem;

    font-weight: ${(props) => props.theme.fontWeight.bolder};
    font-size: 1.2rem;

    color: #929cb9;
    background: ${(props) => props.theme.colors.neutral[135]};

    user-select: none;

    & > span:first-child {
        display: flex;
        padding-left: 2rem;
        gap: 0.5rem;

        & > * {
            display: grid;
            place-items: center;
        }
    }

    & > div:last-child {
        margin-right: 2rem;
        height: 2rem;
        width: 2rem;
        border-radius: 50%;

        display: flex;
        justify-content: center;
        align-items: center;

        &:hover {
            cursor: pointer;
            background: white;
            color: ${(props) => props.theme.colors.neutral[600]};
        }
    }
`;

export default ModalHeader;
